<template>
  <div class="schedule">
    <template v-if="currentSchedule < totalSchedules">
      <div class="loading">
        <img src="@/assets/img/loading_schedule.svg" alt="Зареждане..." />
      </div>
      <p class="center percent">
        {{ Math.floor((currentSchedule / totalSchedules) * 100) }}%
      </p>
    </template>
    <main v-else>
      <table>
        <thead>
          <tr>
            <th v-for="(d, i) in dates" :key="`th-${i}`">
              <p>{{ d.fullDate | formatDateMini }}</p>
              <span>{{ d.fullDate | formatDayName }}</span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(s, i) in schedules" :key="`td-shift-${i}`">
            <template v-for="(d, j) in dates">
              <td
                :key="`td-${j}`"
                v-if="
                  d.schedules
                    ? d.schedules[i]
                      ? d.schedules[i].scheduleGroup
                        ? d.schedules[i].scheduleGroup._id
                        : false
                      : false
                    : false
                "
              >
                <p class="center" v-if="d.schedules[i].loading">зареждане...</p>
                <template v-else>
                  <header
                    :class="`header--${d.schedules[i].shift}`"
                    v-if="
                      d.schedules[i].scheduleGroup
                        ? d.schedules[i].scheduleGroup._id
                        : false
                    "
                  >
                    <div class="icon-and-shift">
                      <span class="icon">e</span>
                      <span class="user-schedule">{{
                        d.schedules[i]._id
                      }}</span>
                    </div>
                    <span
                      class="circle circle--solid"
                      :class="`circle--${d.schedules[i].shift}`"
                      :key="`shift-sp-${j}`"
                    >
                      {{
                        d.schedules[i].shift
                          ? d.schedules[i].scheduleGroup.shifts[
                              d.schedules[i].shift - 1
                            ].name
                          : "П"
                      }}
                    </span>
                  </header>
                  <main
                    v-if="
                      d.schedules[i].users ? d.schedules[i].users.length : false
                    "
                  >
                    <p
                      class="user-item"
                      :class="{
                        'user-item--presence': u.presence,
                        'user-item--vacation': u.vacations,
                        'user-item--illness': u.absence === 'illness',
                        'user-item--maternity': u.absence === 'maternity',
                        'user-item--self-release': u.absence === 'self-release',
                        'user-item--shift-change': u.absence === 'shift-change',
                        'user-item--vacation-hourly': !!u.vh,
                        'user-item--clickable': true,
                      }"
                      :title="u.comment"
                      v-for="u in d.schedules[i].users"
                      :key="`td-${j}-${u._id}`"
                      @click="
                        toggleAbsence(
                          d.fullDate,
                          u,
                          d.schedules[i].scheduleGroup,
                          d.schedules[i]._id,
                          i,
                          d.schedules[i].shift - 1
                        )
                      "
                    >
                      <label>{{ u.name }}</label>
                      <transition name="fade" appear>
                        <span
                          class="circle circle--mini"
                          :class="`circle--orange`"
                          v-if="u.absence === 'shift-change'"
                        >
                          {{ u.shift || "П" }}
                        </span>
                        <img v-if="u.vacations" src="@/assets/img/schedule/approved.png" alt="">
                        <img v-else-if="u.absence === 'illness'" src="@/assets/img/schedule/illness.png" alt="">
                        <img v-else-if="u.absence === 'maternity'" src="@/assets/img/schedule/maternity.png" alt="">
                        <img v-else-if="u.absence === 'self-release'" src="@/assets/img/schedule/self-release.png" alt="">
                        <img v-else-if="u.vh === '0016'" src="@/assets/img/schedule/home_office.png" alt="">
                        <img v-else-if="u.vh === '0012'" src="@/assets/img/schedule/full_day_note.png" alt="">
                        <img v-else-if="u.vh === '0045'" src="@/assets/img/schedule/full_day.png" alt="">
                      </transition>
                    </p>
                  </main>
                  <p class="center" v-else>
                    <template v-if="d.schedules[i].scheduleGroup._id"
                      >Няма данни</template
                    >
                  </p>
                </template>
                <!-- </template> -->
              </td>
            </template>
          </tr>
        </tbody>
      </table>
    </main>
    <AbsenceModal
      v-if="selectedDate && selectedUser"
      :user="selectedUser"
      :date="selectedDate"
      :scheduleGroup="selectedScheduleGroup"
      :schedule="selectedSchedule"
      :shift="selectedShift"
      @close="closeAbsence"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import AbsenceModal from "./AbsenceModal";
export default {
  components: {
    AbsenceModal,
  },
  computed: {
    ...mapGetters(["currentUser"]),
  },
  watch: {
    $route: {
      handler: "getSchedules",
      immediate: true,
    },
  },
  data() {
    return {
      today: new Date(),
      date: null,
      schedules: [],
      dates: [],
      selectedDate: null,
      selectedUser: null,
      selectedSchedule: null,
      selectedScheduleGroup: null,
      selectedShift: null,
      indexOfSelectedSchedule: null,

      totalSchedules: 0,
      currentSchedule: 0,
      initializations: 0,
    };
  },
  methods: {
    getSchedules() {
      this.initializations += 1;
      this.schedules = [];
      let url = `/users/all-schedules?date=${this.$route.query.date}`;
      if (this.$route.name === "scheduleShiftAll") url += "&all=true";
      this.$apiService.get(url).then((res) => {
        for (let schedule of res.data) {
          this.schedules.push(schedule);
        }

        this.getDates();
      });
    },
    async getDates() {
      const initialization = this.initializations;
      this.dates = [];
      this.totalSchedules = 0;
      this.currentSchedule = 0;
      this.date = this.$route.query.date ? new Date(this.$route.query.date) : new Date();

      try {
        const res = await this.$apiService.get(`/days/week/${this.date}`);
        if (this.initializations !== initialization) return;

        this.dates = res.data.map((d) => ({
          ...d,
          schedules: this.schedules.map((schedule) => ({
            ...schedule,
            loading: true,
            scheduleGroup: {},
            users: [],
            shift: null,
          })),
        }));

        this.totalSchedules = this.schedules.length * this.dates.length;

        const tasks = [];
        for (const d of this.dates) {
          for (const cell of d.schedules) {
            tasks.push(async () => {
              if (this.initializations !== initialization) return;

              try {
                await this.getScheduleGroupForDate(d, cell);
              } catch (e) {
                console.error('Failed cell', d.fullDate, cell._id, e);
              } finally {
                if (this.initializations === initialization) {
                  this.currentSchedule += 1;
                }
              }
            });
          }
        }

        await this.runWithLimit(tasks, 8);
      } catch (e) {
        console.error('getDates failed', e);
      }
    },
    async runWithLimit(tasks, limit = 10) {
      const executing = new Set();

      for (const task of tasks) {
        const p = Promise.resolve()
          .then(task)
          .finally(() => executing.delete(p));
        executing.add(p);

        if (executing.size >= limit) {
          await Promise.race(executing);
        }
      }

      await Promise.all(executing);
    },
    async getScheduleGroupForDate(d, s) {
      this.$set(s, 'loading', true);

      try {
        const url = `/schedule-groups/${s._id}/${d.fullDate}`;
        const resp = await this.$apiService.get(url);

        this.$set(s, 'scheduleGroup', resp.data || {});

        if (s.scheduleGroup && s.scheduleGroup._id) {
          this.generatePattern(d, s);
          await this.getUsers(d, s);
        }
      } finally {
        this.$set(s, 'loading', false);
      }
    },
    generatePattern(d, s) {
      if (d.holiday && s.scheduleGroup.skipHolidays) {
        return this.$set(s, "shift", null);
      }

      const firstDayOfScheduleGroup = new Date(s.scheduleGroup.dateFrom);
      const firstDayOfWeek = new Date(d.fullDate);
      const difference = Math.ceil(
        Math.abs(firstDayOfWeek - firstDayOfScheduleGroup) /
          (1000 * 60 * 60 * 24)
      );
      const offset = difference % s.scheduleGroup.pattern.length;

      let position = offset
        ? offset - 1
        : s.scheduleGroup.schedules.pattern.length - 1;

      this.$set(s, "shift", s.scheduleGroup.schedules.pattern[position]);
    },
    async getUsers(d, s) {
      let url = `/schedule-groups/${s._id}/${d.fullDate}/users`;
      url += `?weekend=${d.weekend}`;
      url += `&shift=${s.shift ? true : false}`;
      if (this.$route.name === "scheduleShiftAll") url += "&all=true";

      const resp = await this.$apiService.get(url);
      this.$set(s, "users", resp.data || []);
    },
    clearAbsenceSelection() {
      this.selectedDate = null;
      this.selectedUser = null;
      this.selectedSchedule = null;
      this.selectedScheduleGroup = null;
      this.selectedShift = null;
      this.indexOfSelectedSchedule = null;
    },
    toggleAbsence(d, u, s, schedule, i, sh) {
      this.selectedDate = d;
      this.selectedUser = u;
      this.selectedScheduleGroup = s;
      this.selectedSchedule = schedule;
      this.indexOfSelectedSchedule = i;

      if (sh > -1) {
        this.selectedShift = s.shifts[sh].name;
      } else this.selectedShift = null;
    },
    closeAbsence(update) {
      if (update) {
        for (let d of update.totalDays) {
          const date = this.dates.find((x) => {
            return x.fullDate === d;
          });

          if (date) {
            if (date.schedules[this.indexOfSelectedSchedule].users) {
              const u = date.schedules[this.indexOfSelectedSchedule].users.find(
                (x) => {
                  return x._id === update.user;
                }
              );

              if (u) {
                if (update.deleted) {
                  this.$set(u, "absence", null);
                  this.$set(u, "shift", null);
                  this.$set(u, "comment", null);
                } else {
                  this.$set(u, "absence", update.type);
                  this.$set(u, "comment", update.comment);
                  if (update.type === "shift-change") {
                    this.$set(u, "shift", update.shift);
                  }
                }
              }
            }
          }
        }
      }
      this.clearAbsenceSelection();
    },
  },
  mounted() {
    this.today.setHours(0, 0, 0, 0);
  },
  destroyed() {
    this.initializations = 0;
  },
};
</script>

<style lang="scss" scoped>
@import "@/scss/base.scss";
.schedule {
  height: 100%;
  width: 100%;
  padding: 10px;
  position: relative;
  > main {
    table {
      // border: 1px solid red;
      border-collapse: collapse;
      width: 100%;
      th,
      td {
        border: 1px solid #d3d3d3;
        // max-width: 1%;
        // width: 1%;
        // max-width: 14.2857143%;
        // width: 14.2857143%;
        width: calc((100% / 7));
        &:first-child {
          border-left: 1px solid transparent;
        }
        &:last-child {
          border-right: 1px solid transparent;
        }
      }
      th {
        border-top: 1px solid transparent;
        font-weight: 500;
        padding: 9px;
        p {
          font-size: $px16;
          margin-bottom: 3px;
        }
        span {
          font-size: $px11;
          text-transform: uppercase;
        }
      }
      td {
        border-bottom: 1px solid transparent;
        padding: 6px 10px;
        vertical-align: top;
        header {
          align-items: center;
          background-color: rgba($color: #ababab, $alpha: 0.2);
          border-radius: 4px;
          display: flex;
          height: 40px;
          justify-content: space-between;
          margin-bottom: $px14;
          padding: 10px;
          .icon-and-shift {
            align-items: center;
            display: flex;
          }
          .icon {
            font-size: 20px;
            margin-right: 10px;
          }
          .user-schedule {
            font-size: $px14;
            font-weight: 500;
            margin-right: 10px;
          }
          .circle {
            margin: 0;
          }
          &.header--1 {
            background-color: rgba($color: #005fc2, $alpha: 0.2);
          }
          &.header--2 {
            background-color: rgba($color: #00c273, $alpha: 0.2);
          }
          &.header--3 {
            background-color: rgba($color: #9600c2, $alpha: 0.2);
          }
        }
        main {
          .user-item {
            align-items: center;
            border: 1px solid #dedede;
            border-radius: 2px;
            font-size: $px11;
            font-weight: 500;
            margin-bottom: 5px;
            display: flex;
            justify-content: space-between;
            gap: 5px;
            padding: 10px;
            position: relative;
            text-transform: uppercase;

            label {
              flex-basis: 70%;
            }

            &.user-item--presence {
              background-color: #edffc8;
              border: 1px solid #6c9f01;
            }
            &.user-item--illness {
              background-color: #ffcccc;
              border: 1px solid #ce614b;
            }
            &.user-item--maternity {
              background-color: #fdcbfb;
              border: 1px solid #8400b2;
            }
            &.user-item--self-release {
              background-color: #d4d4d4;
              border: 1px solid #505050;
            }
            &.user-item--vacation {
              background-color: #cbfdfd;
              border: 1px solid #14d2f9;
            }
            &.user-item--vacation-hourly {
              background-color: #F7F7F7;
            }
            // &.user-item--shift-change {
            // }
            &.user-item--clickable {
              @include hover();
              &:not(.user-item--illness):not(.user-item--self-release):not(.user-item--shift-change):not(.user-item--vacation):not(.user-item--maternity):not(.user-item--presence):not(.user-item--vacation-hourly):hover {
                background-color: rgba(222, 222, 222, 0.5);
              }
            }
            .circle {
              margin-right: initial;
              // margin: 0;
              // position: absolute;
              // right: 4px;
              // top: 50%;
              // @include transform(translateY(-50%));
            }
          }
        }
      }
    }
  }
}
.center {
  font-size: $px11;
  font-style: italic;
  opacity: 0.5;
  text-align: center;
}
.percent {
  position: absolute;
  bottom: 1rem;
  left: 0;
  width: 100%;
}
.loading {
  align-items: center;
  display: flex;
  justify-content: center;
  height: 100%;
  width: 100%;
  img {
    width: 320px;
    max-height: 100%;
  }
}
</style>
